var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "553px",
    height: "604px",
    viewBox: "0 0 5530 6040",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    fill: "#daa520",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1175 5790 c-3 -5 120 -484 274 -1064 155 -580 281 -1060 281 -1067 -1 -8 -352 -302 -780 -653 -429 -352 -780 -643 -780 -647 0 -4 4 -10 9 -13 5 -4 452 -20 992 -36 541 -17 986 -33 989 -37 4 -5 146 -480 315 -1058 169 -577 313 -1056 320 -1063 10 -11 14 -11 22 0 5 7 148 486 318 1063 169 578 311 1053 315 1058 3 4 448 20 989 37 540 16 987 32 992 36 5 3 9 9 9 13 0 4 -351 295 -780 647 -428 351 -779 645 -780 653 0 7 126 487 281 1067 154 580 277 1059 274 1064 -4 7 -14 6 -28 -2 -12 -6 -375 -281 -806 -611 -431 -330 -789 -600 -796 -600 -7 0 -365 270 -796 600 -431 330 -794 605 -806 611 -14 8 -24 9 -28 2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5069154e32e41bc76d7db6ba01f1a809.svg";
export { ForwardRef as ReactComponent };